import { useLatestValue } from "@/src/lib/actions";

export const useOnlyOptions = () => useLatestValue<boolean>("opt:only-options") ?? false;
export const useProvider = () => useLatestValue<"BM" | "NS" | "Helm" | "CYA" | "any">("opt:provider") ?? "any";
export const useSort = () =>
  useLatestValue<"charter_asc" | "charter_desc" | "expiration_asc" | "expiration_desc">("opt:sort") ?? "charter_asc";
export const useSupplier = () => useLatestValue<string>("opt:supplier") ?? "";
